import {DIRECT_MESSAGES_ACTIONS, PAGES_ACTIONS} from "../constants";

const initState = {
    conversations: [],
    messagesList: [],
    lastActive: null,
    unarchivedConvosCount: 0,
    unarchivedCount: 0,
    filters: {
        top: {
            read: ""
        },
        bottom: {
            resolved: "",
            archived: "",
            page_id: ""
        },
    }
}


export function directMessagesReducer(state=initState, action) {
    const {payload} = action

    switch (action.type) {
        case DIRECT_MESSAGES_ACTIONS.REQUEST_CONVOS:
            return {
                ...state,
                conversations: payload.data
            }
        case DIRECT_MESSAGES_ACTIONS.REQUEST_MESSAGES:
            return {
                ...state,
                messagesList: Array.isArray(payload.data) ? payload.data : [],
            }

        case DIRECT_MESSAGES_ACTIONS.REQUEST_MORE_MESSAGES_SUCCESS:
            return {
                ...state,
                messagesList: [...(payload.data || []), ...state.messagesList],
            };

        case DIRECT_MESSAGES_ACTIONS.ADD_DIRECT_MESSAGES:
            return {
                ...state,
                messagesList: [...state.messagesList, payload.data],
            }
        case DIRECT_MESSAGES_ACTIONS.UPDATE_DIRECT_MESSAGE:
            return {
                ...state,
                messagesList: state.messagesList.map(m => {
                    if (m.id === payload.messageId) {
                        return {
                            ...m,
                            attributes: Object.assign(m.attributes, payload.attributes)
                        }
                    } else {
                        return {
                            ...m
                        }
                    }
                })
            }
        case DIRECT_MESSAGES_ACTIONS.DELETE_DIRECT_MESSAGE:
            return {
                ...state,
                messagesList: state.messagesList.filter(message => message.id !== payload.messageId)
            }
        case DIRECT_MESSAGES_ACTIONS.ADD_LAST_ACTIVE:
            return {
                ...state,
                lastActive: payload.data
            }
        case DIRECT_MESSAGES_ACTIONS.ADD_CONVO:
            return {
                ...state,
                conversations: [payload.data, ...state.conversations]
            }
        case DIRECT_MESSAGES_ACTIONS.UPDATE_CONVO:
            return {
                ...state,
                conversations: state.conversations.map(s => {
                    if (s.id === payload.convoId) {
                        return {
                            ...s,
                            attributes: Object.assign(s.attributes, payload.attributes)
                        }
                    } else {
                        return {
                            ...s
                        }
                    }
                })
            }
        case DIRECT_MESSAGES_ACTIONS.DELETE_CONVO:
            return {
                ...state,
                conversations: state.conversations.filter(convo => convo.id !== payload.convoId)
            }
        case DIRECT_MESSAGES_ACTIONS.CHANGE_DM_FILTER:
            return {
                ...state,
                filters: payload.top ? {
                    bottom: {...state.filters.bottom},
                    top: {[payload.name]: payload.value}} : {
                    top: {...state.filters.top},
                    bottom: payload.name ? {...initState.filters.bottom, [payload.name]: payload.value} : {...initState.filters.bottom}
                }
            }
        case DIRECT_MESSAGES_ACTIONS.SET_UNARCHIVED_CONVOS_COUNT:
            return{
                ...state,
                unarchivedConvosCount: payload.num
            }
        case DIRECT_MESSAGES_ACTIONS.REQUEST_MESSAGES_COUNTER_SUCCESS:
            return {
                ...state,
                unarchivedCount: payload.num
            }
        case DIRECT_MESSAGES_ACTIONS.CONVO_TO_TOP:
            if (state.conversations.length > 1){
                const index = state.conversations.findIndex( s => s.id === payload.convoId )
                state.conversations.unshift(state.conversations.splice(index, 1)[0])
            }
            return{
                ...state,
                conversations: state.conversations
            }
        default:
            return state
    }
}



// payload.name ? {
//     ...initState.filters,
//     [payload.name]: payload.value
// } : {...initState.filters}